import { getObjectUtil } from 'packages/src'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getCurrentWorkoutSectionIndexStartWorkoutSelect from '../get-current-workout-section-index'
import WORKOUT_SECTIONS_PATH from '../../../workout-section/redux/constants/path'
import getWorkoutSectionsWorkoutUtil from '../../../workout/model/utils/get-workout-sections'
import getStartedWorkoutSelect from '../../../workout/redux/selectors/get-started'
import { createSelector } from 'reselect'

const getCurrentWorkoutSectionStartWorkoutSelect = createSelector(
  state => getObjectUtil(state, WORKOUT_SECTIONS_PATH.DATA),
  getStartedWorkoutSelect,
  getCurrentWorkoutSectionIndexStartWorkoutSelect,
  (workoutSectionsDomainMap, workout, curWorkoutSectionIndex) => {
    if (!workout) {
      return
    }
    const workoutSectionPointers = getWorkoutSectionsWorkoutUtil(workout)
    const curWorkoutSectionPointer = workoutSectionPointers[curWorkoutSectionIndex]
    if (!curWorkoutSectionPointer) {
      return
    }
    const dMapVal = getIdReduxUtil(curWorkoutSectionPointer)
    return workoutSectionsDomainMap[dMapVal]
  }
)

export default getCurrentWorkoutSectionStartWorkoutSelect
